import React, {  useState } from 'react';
import { injectIntl } from 'react-intl';
import { cleanFieldProps, parseClasses } from '../../lib/ep.js';

import Checkbox, { Checkbox as FrontCheckbox } from './Checkbox.js';
import DisabledArea from './DisabledArea';
import FieldWrapper from './FieldWrapper.js';

const CheckBoxGroup = (props)=> {
	const [ selected, setSelected ] = useState((props.model != undefined && props.model[props.name] != undefined) ? props.model[props.name] : []);

	const toggle = (value) => {
		const new_selected = selected.includes(value) ? selected.filter((item) => (item !== value)) : [ ...selected, value ];
		const encoded = JSON.stringify(new_selected);
		if(props.change_cb != undefined) props.change_cb(encoded);
		if(props.change != undefined) props.change(props.name, encoded);
		setSelected(new_selected);
	};

	if(props.elements.length == 0) return null;

	let classname = props?.classname ?? 'input checkbox_group';
	classname = parseClasses(classname, props._class, 'checkgroup');

	const disabled = props?.disabled ?? false;
	const is_builder = props?.is_builder ?? false;

	const wrapper_props = cleanFieldProps(props);

	let field_class = [];
	if(disabled) field_class.push('disabledField');
	if(props._check_class != undefined) field_class.push(props._check_class);

	const Component = (is_builder) ? Checkbox : FrontCheckbox;

	return (
		<FieldWrapper type='checkbox_group' {...wrapper_props}>
			{props.elements.map((p, i) => {
				const autotranslate = (p.label?.type != undefined && typeof p.label != 'string' && p.label != '') ? false : true;
				const enabled = (p.off == undefined || !p.off) ? true : false;

				return (
					<DisabledArea
						key={i}
						disabled={(!enabled) ? true : false}
						message={p.off_message}
					>
						<div class={`checkbox_row${((!enabled) ? ' fields_grouper gui_disabledItem' : '')}`}>
							<Component
								name={p.value}
								_class={{...field_class, first:(i==0) ? true : false}}
								value={selected.includes(p.value)}
								change={toggle}
								autotranslate={autotranslate}
							>{p.label}</Component>
						</div>
					</DisabledArea>
				)
			})}
		</FieldWrapper>
	);
}

export default injectIntl(CheckBoxGroup);